const testIds = {
  // NAVIGATION MENU
  UNIVERSAL_SEARCH_INPUT: "universal-search-input",
  UNIVERSAL_SEARCH_RESULTS: "universal-search-results",
  MENU_LOGO: "menu-logo",
  MENU_DASHBOARD_BUTTON: "menu-dashboard-button",
  MENU_FEEDBACK_BUTTON: "menu-feedback-button",
  MENU_SHIPMENTS_BUTTON: "menu-shipments-button",
  MENU_INVOICES_BUTTON: "menu-invoices-button",
  MENU_QUICK_REQUESTS_BUTTON: "menu-quick-requests-button",
  MENU_QUOTE_REQUESTS_BUTTON: "menu-quote-requests-button",
  MENU_TASKS_BUTTON: "menu-tasks-button",
  MENU_RATES_BUTTON: "menu-rates-button",
  MENU_ANALYTICS_BUTTON: "menu-reports-button",
  MENU_SETTINGS_BUTTON: "menu-settings-button",
  MENU_LOGOUT_BUTTON: "menu-logout-button",
  MENU_ADD_BUTTON: "menu-add-button",
  MENU_ADD_SHIPMENT_BUTTON: "menu-add-shipment-button",
  MENU_ADD_MBL_BUTTON: "menu-add-MBL-button",
  MENU_ADD_TRACKER_BUTTON: "menu-add-tracker-button",
  MENU_ADD_QUICK_REQUEST_BUTTON: "menu-add-quick-request-button",
  MENU_ADD_QUOTE_REQUEST_BUTTON: "menu-add-quote-request-button",
  MENU_EXPAND_BUTTON: "menu-expand-button",
  RECENT_MENU: "recent-menu",
  RECENT_LAST_VISITS: "recent-last-visits",
  RECENT_LAST_SEARCHES: "recent-last-searches",
  // DASHBOARD
  LAYOUT_LOCK_BUTTON: "layout-lock-button",
  RESET_WIDGETS_BUTTON: "reset-widgets-button",
  ADD_WIDGET_BUTTON: "add-widget-button",
  OPEN_WIDGET_DIALOG_BUTTON: "open-widget-dialog-button",
  EDIT_WIDGET_BUTTON: "edit-widget-button",
  WIDGET_DIALOG_LIST_BUTTON: "list-widget-button",
  WIDGET_DIALOG_STATUS_BUTTON: "status-widget-button",
  WIDGET_DIALOG_QUICK_ACTIONS_BUTTON: "quick-actions-widget-button",
  WIDGET_DIALOG_MAP_BUTTON: "map-widget-button",
  WIDGET_DIALOG_ADD_BUTTON: "widget-dialog-add-button",
  WIDGET_DIALOG_DELETE_BUTTON: "widget-dialog-delete-button",
  WIDGET_DIALOG_SAVE_BUTTON: "widget-dialog-save-button",
  // LIST VIEWS
  LIST_SEARCH_INPUT: "list-view-search-input",
  LIST_LOCATION_FILTER_DROPDOWN: "list-view-location-filter-dropdown",
  LIST_LOCATION_FILTER_OPTION: "list-view-location-filter-option",
  LIST_DUPLICATE_BUTTON: "list-view-duplicate-button",
  LIST_DUPLICATE_CONFIRM_BUTTON: "list-view-duplicate-confirm-button",
  // FORM
  FORM_SAVE_BUTTON: "form-save-button",
  FORM_NEXT_BUTTON: "form-next-button",
  FORM_PREVIOUS_BUTTON: "form-previous-button",
  FORM_SUBMIT_BUTTON: "form-submit-button",
  FORM_OPEN_TEMPLATE_DIALOG_BUTTON: "form-open-template-dialog-button",
  FORM_CONFIRM_LOAD_TEMPLATE_BUTTON: "form-confirm-load-template-button",
  FORM_DELETE_TEMPLATE_BUTTON: "form-delete-template-button",
  FORM_DELETE_PRESET_BUTTON: "form-delete-preset-button",
  FORM_ADDRESS_SAVE_BUTTON: "form-address-save-button",
  // SHIPMENT DASHBOARD
  SHIPMENT_DASHBOARD_CONVERT_BUTTON: "shipment-dashboard-convert-button",
  SHIPMENT_DASHBOARD_QUOTES_TAB: "shipment-dashboard-quotes-tab",
  SHIPMENT_DASHBOARD_TRACKING_TAB: "shipment-dashboard-tracking-tab",
  SHIPMENT_DASHBOARD_BILLING_TAB: "shipment-dashboard-billing-tab",
  SHIPMENT_DASHBOARD_AUDIT_TRAIL_TAB: "shipment-dashboard-audit-trail-tab",
  SHIPMENT_DASHBOARD_DETAILS_TAB: "shipment-dashboard-details-tab",
  SHIPMENT_DASHBOARD_EXPORT_BUTTON: "shipment-dashboard-export-button",
  SHIPMENT_DASHBOARD_EXPORT_REQUEST_CSV_BUTTON: "shipment-dashboard-export-request-csv-button",
  SHIPMENT_DASHBOARD_EXPORT_REQUEST_PDF_BUTTON: "shipment-dashboard-export-request-pdf-button",
  SHIPMENT_DASHBOARD_EXPORT_QUOTE_XLSX_BUTTON: "shipment-dashboard-export-quote-xlsx-button",
  SHIPMENT_DASHBOARD_EXPORT_QUOTE_PDF_BUTTON: "shipment-dashboard-export-quote-pdf-button",
  SHIPMENT_DASHBOARD_EXPORT_SHIPMENT_PDF_BUTTON: "shipment-dashboard-export-shipment-pdf-button",
  SHIPMENT_DASHBOARD_DUPLICATE_BUTTON: "shipment-dashboard-duplicate-button",
  SHIPMENT_DASHBOARD_CANCEL_BUTTON: "shipment-dashboard-cancel-button",
  SHIPMENT_DASHBOARD_COST_DETAILS_BUTTON: "shipment-dashboard-cost-details-button",
  SHIPMENT_DASHBOARD_QUOTE_EXPANSION: "shipment-dashboard-quote-expansion",
  SHIPMENT_DASHBOARD_QUOTE_CHARGEABLE_WEIGHT: "shipment-dashboard-quote-chargeable-weight",
  SHIPMENT_DASHBOARD_QUOTE_TOTAL_CBM: "shipment-dashboard-quote-total-cbm",
  SHIPMENT_DASHBOARD_QUOTE_CHARGES_TABLE: "shipment-dashboard-quote-charges-table",
  SHIPMENT_DASHBOARD_QUOTE_COST_ROW_PREFIX: "shipment-dashboard-quote-cost-row-",
  SHIPMENT_DASHBOARD_QUOTE_COST_FORMULA_PREFIX: "shipment-dashboard-quote-cost-formula-",
  SHIPMENT_DASHBOARD_SERVICE_CONFIRMATION_BUTTON: "shipment-dashboard-service-confirmation-button",
  SHIPMENT_DASHBOARD_EDIT_BUTTON: "shipment-dashboard-edit-button",
  SHIPMENT_DASHBOARD_EDIT_ORGANISATION_MODAL: "shipment-dashboard-edit-organisation-modal",
  SHIPMENT_DASHBOARD_EDIT_ORGANISATION_MODAL_CLOSE: "shipment-dashboard-edit-organisation-modal-close",
  SHIPMENT_DASHBOARD_EDIT_ORGANISATION_TITLE: "shipment-dashboard-edit-organisation-title",
  SHIPMENT_DASHBOARD_EDIT_ORGANISATION_SAVE: "shipment-dashboard-edit-organisation-save",
  SHIPMENT_DASHBOARD_MENU_BUTTON: "shipment-dashboard-menu-button",
  SHIPMENT_DASHBOARD_DELETE_BUTTON: "shipment-dashboard-delete-button",
  SHIPMENT_DASHBOARD_DELETE_CONFIRM_BUTTON: "shipment-dashboard-delete-confirm-button",
  SHIPMENT_DASHBOARD_NOTIFICATIONS_TOGGLE_BUTTON: "shipment-dashboard-notifications-toggle-button",
  SHIPMENT_DASHBOARD_EDIT_TIMERS_BUTTON: "shipment-dashboard-edit-timers-button",
  SHIPMENT_DASHBOARD_EDIT_TIMERS_CONFIRM_BUTTON: "shipment-dashboard-edit-timers-confirm-button",
  SHIPMENT_DASHBOARD_EDIT_CUSTOM_LONGFIELD_BUTTON: "shipment-dashboard-edit-custom-longfield-button",
  SHIPMENT_DASHBOARD_EDIT_CUSTOM_LONGFIELD_CONFIRM_BUTTON: "shipment-dashboard-edit-custom-longfield-confirm-button",
  SHIPMENT_DASHBOARD_INVITED_PROVIDERS_SECTION: "shipment-dashboard-invited-providers-section",
  SHIPMENT_DASHBOARD_OPEN_INVITE_PROVIDER_MODAL_BUTTON: "shipment-dashboard-open-invite-provider-modal-button",
  SHIPMENT_DASHBOARD_PROVIDER_MORE_OPTIONS_BUTTON: "shipment-dashboard-provider-more-options-button",
  SHIPMENT_DASHBOARD_INVITE_PROVIDER_BUTTON: "shipment-dashboard-invite-provider-button",
  SHIPMENT_DASHBOARD_INVITE_PROVIDER_MODAL_CLOSE_BUTTON: "shipment-dashboard-invite-provider-modal-close-button",
  SHIPMENT_DASHBOARD_REVOKE_PROVIDER_INVITE_BUTTON: "shipment-dashboard-revoke-provider-invite-button",
  SHIPMENT_DASHBOARD_COMMENT_INPUT: "shipment-dashboard-comment-input",
  SHIPMENT_DASHBOARD_COMMENT_AUDIENCE_DROPDOWN: "shipment-dashboard-comment-audience-dropdown",
  SHIPMENT_DASHBOARD_COMMENT_SUBMIT_BUTTON: "shipment-dashboard-comment-submit-button",
  SHIPMENT_DASHBOARD_BOOK_QUOTE_BUTTON: "shipment-dashboard-book-quote-button",
  SHIPMENT_DASHBOARD_REQUEST_APPROVAL_BUTTON: "shipment-dashboard-request-approval-button",
  SHIPMENT_DASHBOARD_APPROVE_REQUEST_QUOTE_BUTTON: "shipment-dashboard-approve-request-quote-button",
  SHIPMENT_DASHBOARD_DECLINE_REQUEST_APPROVAL_BUTTON: "shipment-dashboard-decline-request-approval-button",
  SHIPMENT_DASHBOARD_SUBMIT_POD_BUTTON: "shipment-dashboard-submit-pod-button",
  SHIPMENT_DASHBOARD_SUBMIT_POD_CONFIRM_BUTTON: "shipment-dashboard-submit-pod-confirm-button",
  SHIPMENT_DASHBOARD_PROOF_OF_DELIVERY_MENU_BUTTON: "shipment-dashboard-proof-of-delivery-menu-button",
  SHIPMENT_DASHBOARD_PROOF_OF_DELIVERY_MENU_LIST: "shipment-dashboard-proof-of-delivery-menu-list",
  SHIPMENT_DASHBOARD_PROOF_OF_DELIVERY_MENU_MASTER_ROW: "shipment-dashboard-proof-of-delivery-menu-master-row",
  SHIPMENT_DASHBOARD_PROOF_OF_DELIVERY_MENU_ROW_PREFIX: "shipment-dashboard-proof-of-delivery-menu-row-",
  SHIPMENT_DASHBOARD_PROOF_OF_PICKUP_BUTTON: "shipment-dashboard-proof-of-pickup-button",
  SHIPMENT_DASHBOARD_MULTISTOP_POD_DIALOG: "shipment-dashboard-multistop-pod-dialog",
  SHIPMENT_DASHBOARD_MULTISTOP_POD_TYPE_MASTER: "shipment-dashboard-multistop-pod-type-master",
  SHIPMENT_DASHBOARD_MULTISTOP_POD_TYPE_PER_STOP: "shipment-dashboard-multistop-pod-type-per-stop",
  SHIPMENT_DASHBOARD_MULTISTOP_POD_STOP_SELECT: "shipment-dashboard-multistop-pod-stop-select",
  SHIPMENT_DASHBOARD_MULTISTOP_POD_MARK_DELIVERED_YES: "shipment-dashboard-multistop-pod-mark-delivered-yes",
  SHIPMENT_DASHBOARD_MULTISTOP_POD_MARK_DELIVERED_NO: "shipment-dashboard-multistop-pod-mark-delivered-no",
  SHIPMENT_DASHBOARD_MULTISTOP_POD_CONFIRM_BUTTON: "shipment-dashboard-multistop-pod-confirm-button",
  SHIPMENT_DASHBOARD_MULTISTOP_POD_COMPLETION_WARNING: "shipment-dashboard-multistop-pod-completion-warning",
  SHIPMENT_DASHBOARD_POD_BILLING_STATUS: "shipment-dashboard-pod-billing-status",
  SHIPMENT_DASHBOARD_POD_BILLING_STATUS_UNPAID: "shipment-dashboard-pod-billing-status-unpaid",
  SHIPMENT_DASHBOARD_POD_BILLING_STATUS_PAID: "shipment-dashboard-pod-billing-status-paid",
  SHIPMENT_DASHBOARD_TRACKING_UPDATE_INPUT: "shipment-dashboard-tracking-update-input",
  SHIPMENT_DASHBOARD_TRACKING_UPDATE_SUBMIT_BUTTON: "shipment-dashboard-tracking-update-submit-button",
  SHIPMENT_DASHBOARD_TRACKING_REFERENCE_MODAL_BUTTON: "shipment-dashboard-tracking-reference-modal-button",
  SHIPMENT_DASHBOARD_TRACKING_REFERENCE_STOP_SELECT: "shipment-dashboard-tracking-reference-stop-select",
  SHIPMENT_DASHBOARD_TRACKING_REFERENCE_SUBMIT_BUTTON: "shipment-dashboard-tracking-reference-submit-button",
  SHIPMENT_DASHBOARD_TRACKING_ITEM_ASSOCIATED_STOP: "shipment-dashboard-tracking-item-associated-stop",
  SHIPMENT_DASHBOARD_INVITE_GUEST_BUTTON: "shipment-dashboard-invite-guest-button",
  SHIPMENT_DASHBOARD_INVITE_GUEST_INPUT: "shipment-dashboard-invite-guest-input",
  SHIPMENT_DASHBOARD_INVITE_GUEST_SUBMIT_BUTTON: "shipment-dashboard-invite-guest-submit-button",
  SHIPMENT_DASHBOARD_AUDIT_STATUS_DROPDOWN: "shipment-dashboard-audit-status-dropdown",
  SHIPMENT_DASHBOARD_AUDIT_STATUS_SUBMIT_BUTTON: "shipment-dashboard-audit-status-submit-button",
  SHIPMENT_DASHBOARD_AUDIT_LOG: "shipment-dashboard-audit-log",
  SHIPMENT_DASHBOARD_SAVE_TEMPLATE_BUTTON: "shipment-dashboard-save-template-button",
  SHIPMENT_DASHBOARD_PRINT_BUTTON: "shipment-dashboard-print-button",
  SHIPMENT_DASHBOARD_DOWNLOAD_DETAILS_AS_PDF_BUTTON: "shipment-dashboard-download-details-as-pdf-button",
  SHIPMENT_DASHBOARD_ASSIGN_MODAL_CLOSE_BUTTON: "shipment-dashboard-assign-modal-close-button",
  SHIPMENT_DASHBOARD_DECLINE_BUTTON: "shipment-dashboard-decline-button",
  SHIPMENT_DASHBOARD_MODAL_ASSIGN_BUTTON: "shipment-dashboard-modal-assign-button",
  SHIPMENT_DASHBOARD_DECLINE_MODAL_CLOSE_BUTTON: "shipment-dashboard-decline-modal-close-button",
  SHIPMENT_DASHBOARD_UNDECLINE_MODAL_CLOSE_BUTTON: "shipment-dashboard-undecline-modal-close-button",
  SHIPMENT_DASHBOARD_UNDECLINE_UNDO_BUTTON: "shipment-dashboard-undecline-modal-undo-button",
  SHIPMENT_DASHBOARD_RELEASE_TEAM_MODAL_CLOSE_BUTTON: "shipment-dashboard-modal-release-team-close-button",
  SHIPMENT_DASHBOARD_RELEASE_ASSIGNMENT_BUTTON: "shipment-dashboard-modal-release-assignment-button",
  SHIPMENT_DASHBOARD_ADDITIONAL_COST_MODAL_BUTTON: "shipment-dashboard-additional-cost-modal-button",
  SHIPMENT_DASHBOARD_ADDITIONAL_COST_SUBMIT_BUTTON: "shipment-dashboard-additional-cost-submit-button",
  SHIPMENT_DASHBOARD_EXTENDED_MODAL_CLOSE_BUTTON: "shipment-dashboard-extended-modal-close-button",
  SHIPMENT_DASHBOARD_EXTENDED_MODAL_EXTEND_BUTTON: "shipment-dashboard-extended-modal-extend-button",
  SHIPMENT_DASHBOARD_QUOTATION_CANCEL_MODAL_CANCEL_BUTTON: "shipment-dashboard-quotation-modal-cancel-button",
  SHIPMENT_DASHBOARD_QUOTATION_CANCEL_MODAL_CANCEL_QUOTE_BUTTON: "shipment-dashboard-quotation-modal-cancel-quote-button",
  SHIPMENT_DASHBOARD_QUOTATION_DUPLICATE_MODAL_CLOSE_BUTTON: "shipment-dashboard-quotation-duplicate-modal-cancel-button",
  SHIPMENT_DASHBOARD_QUOTATION_DUPLICATE_MODAL_DUPLICATE_BUTTON:
    "shipment-dashboard-quotation-duplicate-modal-duplicate-button",
  SHIPMENT_DASHBOARD_UNSUBSCRIBE: "shipment-dashboard-unsubscribe",

  // TOP NAV V2 (Requests Header)
  TOPNAV_V2_ROOT: "topnav-v2-root",
  TOPNAV_V2_HEADER: "topnav-v2-header",
  TOPNAV_V2_SUCCESS_ALERT_CONTAINER: "topnav-v2-success-alert-container",
  TOPNAV_V2_TABS_CONTAINER: "topnav-v2-tabs-container",
  TOPNAV_V2_TOP_ROW: "topnav-v2-top-row",
  TOPNAV_V2_TITLE_SKELETON: "topnav-v2-title-skeleton",
  TOPNAV_V2_BACK_BUTTON: "topnav-v2-back-button",
  TOPNAV_V2_BACK_ICON: "topnav-v2-back-icon",
  TOPNAV_V2_TITLE: "topnav-v2-title",
  TOPNAV_V2_BADGES_ROW: "topnav-v2-badges-row",
  TOPNAV_V2_ACTIONS_CONTAINER: "topnav-v2-actions-container",

  TOPNAV_V2_BADGES_CONTAINER: "topnav-v2-badges-container",
  TOPNAV_V2_BADGE_SHIPMENT_REFERENCE_VALUE: "topnav-v2-badge-shipment-reference-value",
  TOPNAV_V2_BADGE_PARENT_SHIPMENT_CONTAINER: "topnav-v2-badge-parent-shipment-container",
  TOPNAV_V2_BADGE_PARENT_SHIPMENT_LINK: "topnav-v2-badge-parent-shipment-link",
  TOPNAV_V2_BADGE_ASSIGNED_TEAM_VALUE: "topnav-v2-badge-assigned-team-value",
  TOPNAV_V2_BADGE_CUSTOMS_BROKER_VALUE: "topnav-v2-badge-customs-broker-value",
  TOPNAV_V2_BADGE_MULTISTOP_VALUE: "topnav-v2-badge-multistop-value",
  TOPNAV_V2_BADGE_OFF_PLATFORM_VALUE: "topnav-v2-badge-off-platform-value",

  TOPNAV_V2_GUEST_ACTIONS_CONTAINER: "topnav-v2-guest-actions",
  TOPNAV_V2_GUEST_ACTIONS_MENU: "topnav-v2-guest-actions-menu",
  TOPNAV_V2_GUEST_ACTIONS_ITEM_PREFIX: "topnav-v2-guest-actions-item-",
  TOPNAV_V2_GUEST_ACTIONS_MORE_ICON: "topnav-v2-guest-actions-more-icon",

  TOPNAV_V2_SHIPPER_PROVIDER_ACTIONS_CONTAINER: "topnav-v2-shipper-provider-actions",
  TOPNAV_V2_MORE_ACTIONS_MENU: "topnav-v2-more-actions-menu",
  TOPNAV_V2_MORE_ACTIONS_ITEM_PREFIX: "topnav-v2-more-actions-item-",
  TOPNAV_V2_MORE_ACTIONS_BUTTON: "topnav-v2-more-actions-button",
  TOPNAV_V2_MORE_ACTIONS_ICON: "topnav-v2-more-actions-icon",

  TOPNAV_V2_EXPORT_CONTAINER: "topnav-v2-export-container",
  TOPNAV_V2_EXPORT_MENU: "topnav-v2-export-menu",
  TOPNAV_V2_EXPORT_MENU_LIST: "topnav-v2-export-menu-list",
  TOPNAV_V2_EXPORT_TOOLTIP: "topnav-v2-export-tooltip",

  TOPNAV_V2_QUICK_REQUEST_DETAILS: "topnav-v2-quick-request-details",
  TOPNAV_V2_QUICK_REQUEST_STATUS_CONTAINER: "topnav-v2-quick-request-status-container",
  TOPNAV_V2_QUICK_REQUEST_STATUS_ITEM: "topnav-v2-quick-request-status-item",
  TOPNAV_V2_QUICK_REQUEST_STATUS_LABEL: "topnav-v2-quick-request-status-label",
  TOPNAV_V2_QUICK_REQUEST_STATUS_VALUE: "topnav-v2-quick-request-status-value",

  TOPNAV_V2_QUOTE_REQUEST_DETAILS: "topnav-v2-quote-request-details",
  TOPNAV_V2_QUOTE_REQUEST_TIMERS_CONTAINER: "topnav-v2-quote-request-timers-container",
  TOPNAV_V2_QUOTE_BY_CONTAINER: "topnav-v2-quote-by-container",
  TOPNAV_V2_QUOTE_BY_LABEL: "topnav-v2-quote-by-label",
  TOPNAV_V2_QUOTE_BY_VALUE: "topnav-v2-quote-by-value",
  TOPNAV_V2_CONFIRM_BY_CONTAINER: "topnav-v2-confirm-by-container",
  TOPNAV_V2_CONFIRM_BY_LABEL: "topnav-v2-confirm-by-label",
  TOPNAV_V2_CONFIRM_BY_VALUE: "topnav-v2-confirm-by-value",
  TOPNAV_V2_EDIT_TIMERS_BUTTON: "topnav-v2-edit-timers-button",
  TOPNAV_V2_EDIT_TIMERS_ICON: "topnav-v2-edit-timers-icon",

  TOPNAV_V2_TRACKING_DETAILS: "topnav-v2-tracking-details",
  TOPNAV_V2_TRACKING_HANDLED_BY_CONTAINER: "topnav-v2-tracking-handled-by",
  TOPNAV_V2_TRACKING_HANDLED_BY_INFO: "topnav-v2-tracking-handled-by-info",
  TOPNAV_V2_TRACKING_HANDLED_BY_LABEL: "topnav-v2-tracking-handled-by-label",
  TOPNAV_V2_TRACKING_HANDLED_BY_VALUE: "topnav-v2-tracking-handled-by-value",
  TOPNAV_V2_TRACKING_RATE_LINK: "topnav-v2-tracking-rate-link",
  TOPNAV_V2_TRACKING_RATE_BUTTON: "topnav-v2-tracking-rate-button",
  TOPNAV_V2_TRACKING_VIEW_CONSOLIDATED_ORDERS_BUTTON: "topnav-v2-tracking-view-consolidated-orders-button",

  TOPNAV_V2_BILLING_DETAILS: "topnav-v2-billing-details",
  TOPNAV_V2_BILLING_STATUS_CONTAINER: "topnav-v2-billing-status-container",
  TOPNAV_V2_BILLING_STATUS_LABEL: "topnav-v2-billing-status-label",
  TOPNAV_V2_BILLING_STATUS_VALUE: "topnav-v2-billing-status-value",
  TOPNAV_V2_BILLING_TOTAL_INVOICED_CONTAINER: "topnav-v2-billing-total-invoiced-container",
  TOPNAV_V2_BILLING_TOTAL_INVOICED_LABEL: "topnav-v2-billing-total-invoiced-label",
  TOPNAV_V2_BILLING_TOTAL_INVOICED_ROW: "topnav-v2-billing-total-invoiced-row",
  TOPNAV_V2_BILLING_TOTAL_INVOICED_VALUE: "topnav-v2-billing-total-invoiced-value",
  TOPNAV_V2_BILLING_TOTAL_INVOICED_CURRENCY: "topnav-v2-billing-total-invoiced-currency",
  TOPNAV_V2_BILLING_TOTAL_INVOICED_AMOUNT: "topnav-v2-billing-total-invoiced-amount",
  TOPNAV_V2_BILLING_TOTAL_QUOTED_CONTAINER: "topnav-v2-billing-total-quoted-container",
  TOPNAV_V2_BILLING_TOTAL_QUOTED_LABEL: "topnav-v2-billing-total-quoted-label",
  TOPNAV_V2_BILLING_TOTAL_QUOTED_VALUE: "topnav-v2-billing-total-quoted-value",
  TOPNAV_V2_BILLING_TOTAL_QUOTED_CURRENCY: "topnav-v2-billing-total-quoted-currency",
  TOPNAV_V2_BILLING_TOTAL_QUOTED_AMOUNT: "topnav-v2-billing-total-quoted-amount",
  TOPNAV_V2_BILLING_CREATED_BY_CONTAINER: "topnav-v2-billing-created-by-container",
  TOPNAV_V2_BILLING_CREATED_BY_LABEL: "topnav-v2-billing-created-by-label",
  TOPNAV_V2_BILLING_CREATED_BY_VALUE: "topnav-v2-billing-created-by-value",
  TOPNAV_V2_BILLING_CREATED_BY_NAME: "topnav-v2-billing-created-by-name",
  TOPNAV_V2_BILLING_CREATED_BY_SUBTITLE: "topnav-v2-billing-created-by-subtitle",
  TOPNAV_V2_BILLING_APPROVED_BY_CONTAINER: "topnav-v2-billing-approved-by-container",
  TOPNAV_V2_BILLING_APPROVED_BY_LABEL: "topnav-v2-billing-approved-by-label",
  TOPNAV_V2_BILLING_APPROVED_BY_VALUE: "topnav-v2-billing-approved-by-value",
  TOPNAV_V2_BILLING_APPROVED_BY_EMAIL_LINK: "topnav-v2-billing-approved-by-email-link",
  TOPNAV_V2_BILLING_APPROVED_BY_NAME: "topnav-v2-billing-approved-by-name",

  TOPNAV_V2_BOOKMARK_TOGGLE: "topnav-v2-bookmark-toggle",
  TOPNAV_V2_BOOKMARK_TOGGLE_ICON: "topnav-v2-bookmark-toggle-icon",

  // ANALYTICS
  ANALYTICS_CREATE_REPORT_BUTTON: "analytics-create-report-button",
  ANALYTICS_CREATE_REPORT_SUBMIT_BUTTON: "analytics-create-report-submit-button",
  ANALYTICS_REPORT_DOWNLOAD_BUTTON: "analytics-report-download-button",
  ANALYTICS_REPORT_DELETE_BUTTON: "analytics-report-delete-button",
  ANALYTICS_REPORT_DELETE_CONFIRM_BUTTON: "analytics-report-delete-confirm-button",
  ANALYTICS_GENERATE_REPORT_BUTTON: "analytics-generate-report",
  ANALYTICS_REPORT_TAB: "analytics-report-tab",
  ANALYTICS_SCHEDULED_REPORT_NEW_BUTTON: "analytics-scheduled-report-new-button",
  ANALYTICS_SCHEDULED_REPORT_EDIT_BUTTON: "analytics-scheduled-report-edit-button",
  ANALYTICS_SCHEDULED_REPORT_DELETE_BUTTON: "analytics-scheduled-report-delete-button",
  ANALYTICS_SCHEDULED_REPORT_DELETE_CONFIRM_BUTTON: "analytics-scheduled-report-delete-confirm-button",
  ANALYTICS_SCHEDULED_REPORT_SUBMIT_BUTTON: "analytics-scheduled-report-submit-button",
  ANALYTICS_SCHEDULED_REPORT_TABLE: "analytics-scheduled-report-table",
  ANALYTICS_LOCATION_TAB: "analytics-location-tab",
  ANALYTICS_FREIGHT_MODE_TAB: "analytics-freight-mode-tab",
  ANALYTICS_BILLING_TAB: "analytics-billing-tab",
  ANALYTICS_PROVIDER_TAB: "analytics-provider-tab",

  // SETTINGS
  YOUR_DETAILS_BUTTON: "your-details-button",
  YOUR_DETAILS_SAVE_BUTTON: "your-details-save-button",
  NOTIFICATIONS_BUTTON: "notifications-button",
  NOTIFICATIONS_SAVE_BUTTON: "notifications-save-button",
  ADDRESS_BOOK_BUTTON: "address-book-button",
  ADDRESS_BOOK_ADD_BUTTON: "address-book-add-button",
  ADDRESS_BOOK_DELETE_BUTTON: "address-book-delete-button",
  ADDRESS_BOOK_SAVE_BUTTON: "address-book-save-button",
  ADDRESS_BOOK_GEOCODED_FILTER_DROPDOWN: "address-book-geocoded-filter-dropdown",
  ADDRESS_BOOK_GEOCODED_TAB_ALL: "address-book-geocoded-tab-all",
  ADDRESS_BOOK_GEOCODED_TAB_GEOCODED: "address-book-geocoded-tab-geocoded",
  ADDRESS_BOOK_GEOCODED_TAB_UNCODED: "address-book-geocoded-tab-uncoded",
  CONTACT_LIST_BUTTON: "contact-list-button",
  CONTACT_LIST_ADD_BUTTON: "contact-list-add-button",
  CONTACT_LIST_DELETE_BUTTON: "contact-list-delete-button",
  CONTACT_LIST_SAVE_BUTTON: "contact-list-save-button",
  PRESETS_AND_TEMPLATES_BUTTON: "preset-and-templates-button",
  // OTHER
  TASK_DIALOG_SUBMIT_BUTTON: "task-dialog-submit-button",
  TIMEZONE_BANNER_UPDATE_BUTTON: "timezone-banner-update-button",
  STAFF_LOGIN_AS_BUTTON: "staff-login-as-button",
  // USER ON BOARDING
  ACTIVATION_EXPIRED_GO_TO_LOGIN: "activation-expired-go-to-login-page",
  ACTIVATE_ACCOUNT_BUTTON: "activate-account-button",
  // PROVIDER QUOTATION FORM
  QUOTATION_FORM_TEMPLATE_REUSE_QUOTATION_BUTTON: "reuse-quotation-button",
  QUOTATION_FORM_TEMPLATE_BACK_TO_QUOTES: "back-to-recent-quotes",
  QUOTATION_FORM_TEMPLATE_CLOSE_BUTTON: "resuse-template-form-close-button",
  FREIGHT_MODE_BUTTON_PREFIX: "freight-mode-",
  FREIGHT_MODE_NFO: "freight-mode-nfo",
  FREIGHT_MODE_OBC: "freight-mode-obc",
  FREIGHT_MODE_REGULAR_AIR: "freight-mode-regular_air",
  FREIGHT_MODE_AIR_CHARTER: "freight-mode-air_charter",
  FREIGHT_MODE_OCEAN_FREIGHT: "freight-mode-ocean_freight",
  FREIGHT_MODE_PARCEL: "freight-mode-parcel",
  FREIGHT_MODE_RAIL_FREIGHT: "freight-mode-rail_freight",
  FREIGHT_MODE_ROAD_FREIGHT: "freight-mode-road_freight",

  // REQUEST FORM
  LOAD_TEMPLATE_BUTTON: "load-template-button",
  REQUEST_FORM_FOOTER_SAVE_DRAFT: "request-form-footer-save-draft",
  REQUEST_FORM_FOOTER_REVIEW: "request-form-footer-review",
  REQUEST_FORM_CONTAINER: "request-form-container",
  REQUEST_FORM_ACCORDION: "request-form-accordion",
  REQUEST_FORM_ORGANISATION_SECTION: "request-form-organisation-section",
  REQUEST_FORM_SCHEDULE_SECTION: "request-form-schedule-section",
  REQUEST_FORM_PACKING_LIST_SECTION: "request-form-packing-list-section",
  REQUEST_FORM_SERVICE_SECTION: "request-form-service-section",
  REQUEST_FORM_PROVIDER_SECTION: "request-form-provider-section",
  REQUEST_FORM_CONFIRMATION_SECTION: "request-form-confirmation-section",
  REQUEST_FORM_REVIEW_PAGE: "request-form-review-page",
  REQUEST_FORM_REVIEW_ORGANISATION: "request-form-review-organisation",
  REQUEST_FORM_REVIEW_SERVICE: "request-form-review-service",
  REQUEST_FORM_REVIEW_SCHEDULE: "request-form-review-schedule",
  REQUEST_FORM_REVIEW_PACKING_LIST: "request-form-review-packing-list",
  REQUEST_FORM_REVIEW_ATTACHMENTS: "request-form-review-attachments",
  REQUEST_FORM_REVIEW_COMMENTS: "request-form-review-comments",
  REQUEST_FORM_REVIEW_SUBMIT: "request-form-review-submit",
  REQUEST_FORM_REVIEW_BACK_TO_EDITING: "request-form-review-back-to-editing",
  REQUEST_FORM_HIDDEN_SUBMIT_BUTTON: "request-form-hidden-submit-button",
  REQUEST_FORM_ORGANISATION_PAYMENT_LOCATION: "request-form-organisation-payment-location",
  REQUEST_FORM_ORGANISATION_INVOICE_LOCATION: "request-form-organisation-invoice-location",
  REQUEST_FORM_ORGANISATION_FREIGHT_MODE: "request-form-organisation-freight-mode",
  REQUEST_FORM_ORGANISATION_ROAD_FREIGHT_OPTION: "request-form-organisation-road-freight-option",
  REQUEST_FORM_ORGANISATION_ADD_MODE_BUTTON: "request-form-organisation-add-mode-button",
  REQUEST_FORM_SCHEDULE_PICKUP_BLOCK: "request-form-schedule-pickup-block",
  REQUEST_FORM_SCHEDULE_DELIVERY_BLOCK: "request-form-schedule-delivery-block",
  REQUEST_FORM_PACKING_LIST_TOTAL_CBM: "request-form-packing-list-total-cbm",
  REQUEST_FORM_PACKING_LIST_TOTAL_WEIGHT: "request-form-packing-list-total-weight",
  REQUEST_FORM_PACKING_LIST_ADD_ITEM_BUTTON: "request-form-packing-list-add-item-button",
  REQUEST_FORM_PACKING_LIST_ADD_CONTAINER_BUTTON: "request-form-packing-list-add-container-button",
  REQUEST_FORM_PACKING_LIST_ADD_HANDLING_UNIT_BUTTON: "request-form-packing-list-add-handling-unit-button",
  REQUEST_FORM_PACKING_LIST_ADD_COMMODITY_BUTTON: "request-form-packing-list-add-commodity-button",
  REQUEST_FORM_PACKING_LIST_HANDLING_UNIT_TABLE: "request-form-packing-list-handling-unit-table",
  REQUEST_FORM_PACKING_LIST_CONTAINER_TABLE: "request-form-packing-list-container-table",
  REQUEST_FORM_PACKING_LIST_COMMODITY_TABLE: "request-form-packing-list-commodity-table",
  REQUEST_FORM_PACKING_LIST_IMPORT_BUTTON: "request-form-packing-list-import-button",
  REQUEST_FORM_PACKING_LIST_GOODS_ESTIMATION: "request-form-packing-list-goods-estimation",
  REQUEST_FORM_SERVICE_INCOTERMS: "request-form-service-incoterms",
  REQUEST_FORM_SERVICE_REQUIREMENT: "request-form-service-requirement",
  REQUEST_FORM_SERVICE_INSURANCE_CHECKBOX: "request-form-service-insurance-checkbox",
  REQUEST_FORM_SERVICE_EXPORT_CLEARANCE: "request-form-service-export-clearance",
  REQUEST_FORM_SERVICE_TRANSIT_CLEARANCE: "request-form-service-transit-clearance",
  REQUEST_FORM_SERVICE_IMPORT_CLEARANCE: "request-form-service-import-clearance",
  REQUEST_FORM_PROVIDER_SEARCH: "request-form-provider-search",
  REQUEST_FORM_PROVIDER_SELECT_ALL_BUTTON: "request-form-provider-select-all-button",
  REQUEST_FORM_PROVIDER_DESELECT_ALL_BUTTON: "request-form-provider-deselect-all-button",
  REQUEST_FORM_PROVIDER_TIMING_QUOTING_DEADLINE_DATE: "request-form-provider-timing-quoting-deadline-date",
  REQUEST_FORM_PROVIDER_TIMING_QUOTING_DEADLINE_TIME: "request-form-provider-timing-quoting-deadline-time",
  REQUEST_FORM_PROVIDER_TIMING_CONFIRMATION_DATE: "request-form-provider-timing-confirmation-date",
  REQUEST_FORM_PROVIDER_TIMING_CONFIRMATION_TIME: "request-form-provider-timing-confirmation-time",
  REQUEST_FORM_PROVIDER_ADD_ATTACHMENTS: "provider-add-attachments",

  // REQUEST FORM - SCHEDULE (DETAILED)
  REQUEST_FORM_SCHEDULE_MULTISTOP_SECTION: "request-form-schedule-multistop-section",
  REQUEST_FORM_SCHEDULE_NOTIFY_PARTY_SECTION: "request-form-schedule-notify-party-section",
  REQUEST_FORM_SCHEDULE_CONSIGNEE_SECTION: "request-form-schedule-consignee-section",
  REQUEST_FORM_SCHEDULE_PICKUP_ADDRESS_TYPE: "request-form-schedule-pickup-address-type",
  REQUEST_FORM_SCHEDULE_DELIVERY_ADDRESS_TYPE: "request-form-schedule-delivery-address-type",
  REQUEST_FORM_SCHEDULE_PICKUP_ADDRESS_SELECT: "request-form-schedule-pickup-address-select",
  REQUEST_FORM_SCHEDULE_DELIVERY_ADDRESS_SELECT: "request-form-schedule-delivery-address-select",
  REQUEST_FORM_SCHEDULE_PICKUP_PORT_SELECT: "request-form-schedule-pickup-port-select",
  REQUEST_FORM_SCHEDULE_DELIVERY_PORT_SELECT: "request-form-schedule-delivery-port-select",
  REQUEST_FORM_SCHEDULE_PICKUP_CONTACT_NAME: "request-form-schedule-pickup-contact-name",
  REQUEST_FORM_SCHEDULE_DELIVERY_CONTACT_NAME: "request-form-schedule-delivery-contact-name",
  REQUEST_FORM_SCHEDULE_PICKUP_CONTACT_PHONE: "request-form-schedule-pickup-contact-phone",
  REQUEST_FORM_SCHEDULE_DELIVERY_CONTACT_PHONE: "request-form-schedule-delivery-contact-phone",
  REQUEST_FORM_SCHEDULE_PICKUP_CONTACT_EMAIL: "request-form-schedule-pickup-contact-email",
  REQUEST_FORM_SCHEDULE_DELIVERY_CONTACT_EMAIL: "request-form-schedule-delivery-contact-email",
  REQUEST_FORM_SCHEDULE_PICKUP_READY_DATE: "request-form-schedule-pickup-ready-date",
  REQUEST_FORM_SCHEDULE_PICKUP_READY_TIME: "request-form-schedule-pickup-ready-time",
  REQUEST_FORM_SCHEDULE_PICKUP_BEFORE_DATE: "request-form-schedule-pickup-before-date",
  REQUEST_FORM_SCHEDULE_PICKUP_BEFORE_TIME: "request-form-schedule-pickup-before-time",
  REQUEST_FORM_SCHEDULE_PICKUP_TIMEZONE: "request-form-schedule-pickup-timezone",
  REQUEST_FORM_SCHEDULE_PICKUP_NOTES: "request-form-schedule-pickup-notes",
  REQUEST_FORM_SCHEDULE_DELIVERY_AFTER_DATE: "request-form-schedule-delivery-after-date",
  REQUEST_FORM_SCHEDULE_DELIVERY_AFTER_TIME: "request-form-schedule-delivery-after-time",
  REQUEST_FORM_SCHEDULE_DELIVERY_BEFORE_DATE: "request-form-schedule-delivery-before-date",
  REQUEST_FORM_SCHEDULE_DELIVERY_BEFORE_TIME: "request-form-schedule-delivery-before-time",
  REQUEST_FORM_SCHEDULE_DELIVERY_TIMEZONE: "request-form-schedule-delivery-timezone",
  REQUEST_FORM_SCHEDULE_DELIVERY_NOTES: "request-form-schedule-delivery-notes",
  REQUEST_FORM_SCHEDULE_NOTIFY_PARTY_ADDRESS_TYPE: "request-form-schedule-notify-party-address-type",
  REQUEST_FORM_SCHEDULE_CONSIGNEE_ADDRESS_TYPE: "request-form-schedule-consignee-address-type",
  REQUEST_FORM_SCHEDULE_NOTIFY_PARTY_ADDRESS_SELECT: "request-form-schedule-notify-party-address-select",
  REQUEST_FORM_SCHEDULE_CONSIGNEE_ADDRESS_SELECT: "request-form-schedule-consignee-address-select",
  REQUEST_FORM_SCHEDULE_NOTIFY_PARTY_PORT_SELECT: "request-form-schedule-notify-party-port-select",
  REQUEST_FORM_SCHEDULE_CONSIGNEE_PORT_SELECT: "request-form-schedule-consignee-port-select",
  REQUEST_FORM_SCHEDULE_NOTIFY_PARTY_CONTACT_NAME: "request-form-schedule-notify-party-contact-name",
  REQUEST_FORM_SCHEDULE_CONSIGNEE_CONTACT_NAME: "request-form-schedule-consignee-contact-name",
  REQUEST_FORM_SCHEDULE_NOTIFY_PARTY_CONTACT_PHONE: "request-form-schedule-notify-party-contact-phone",
  REQUEST_FORM_SCHEDULE_CONSIGNEE_CONTACT_PHONE: "request-form-schedule-consignee-contact-phone",
  REQUEST_FORM_SCHEDULE_NOTIFY_PARTY_CONTACT_EMAIL: "request-form-schedule-notify-party-contact-email",
  REQUEST_FORM_SCHEDULE_CONSIGNEE_CONTACT_EMAIL: "request-form-schedule-consignee-contact-email",
  REQUEST_FORM_SCHEDULE_CONSIGNEE_SAME_AS_DELIVERY: "request-form-schedule-consignee-same-as-delivery",
  REQUEST_FORM_SCHEDULE_NOTIFY_PARTY_SYNC: "request-form-schedule-notify-party-sync",
  REQUEST_FORM_SCHEDULE_NOTIFY_PARTY_SYNC_CUSTOM: "request-form-schedule-notify-party-sync-customAddressContact",
  REQUEST_FORM_SCHEDULE_NOTIFY_PARTY_SYNC_CONSIGNEE:
    "request-form-schedule-notify-party-sync-sameAsConsigneeAddressContact",
  REQUEST_FORM_SCHEDULE_NOTIFY_PARTY_SYNC_DELIVERY:
    "request-form-schedule-notify-party-sync-sameAsDeliveryAddressContact",
  REQUEST_FORM_SCHEDULE_MULTISTOP_ADD_STOP_BUTTON: "request-form-schedule-multistop-add-stop-button",
  REQUEST_FORM_SCHEDULE_MULTISTOP_INSERT_STOP_BUTTON: "request-form-schedule-multistop-insert-stop-button",
  REQUEST_FORM_SCHEDULE_MULTISTOP_INSTRUCTIONS: "request-form-schedule-multistop-instructions",
  REQUEST_FORM_SCHEDULE_MULTISTOP_STOP_CONTAINER_PREFIX: "request-form-schedule-multistop-stop-container",
  REQUEST_FORM_SCHEDULE_MULTISTOP_STOP_ADDRESS_TYPE_PREFIX: "request-form-schedule-multistop-stop-address-type",
  REQUEST_FORM_SCHEDULE_MULTISTOP_STOP_ADDRESS_SELECT_PREFIX: "request-form-schedule-multistop-stop-address-select",
  REQUEST_FORM_SCHEDULE_MULTISTOP_STOP_PORT_SELECT_PREFIX: "request-form-schedule-multistop-stop-port-select",
  REQUEST_FORM_SCHEDULE_MULTISTOP_STOP_TIME_TYPE_PREFIX: "request-form-schedule-multistop-stop-time-type",
  REQUEST_FORM_SCHEDULE_MULTISTOP_STOP_AFTER_DATE_PREFIX: "request-form-schedule-multistop-stop-after-date",
  REQUEST_FORM_SCHEDULE_MULTISTOP_STOP_AFTER_TIME_PREFIX: "request-form-schedule-multistop-stop-after-time",
  REQUEST_FORM_SCHEDULE_MULTISTOP_STOP_BEFORE_DATE_PREFIX: "request-form-schedule-multistop-stop-before-date",
  REQUEST_FORM_SCHEDULE_MULTISTOP_STOP_BEFORE_TIME_PREFIX: "request-form-schedule-multistop-stop-before-time",
  REQUEST_FORM_SCHEDULE_MULTISTOP_STOP_TIMEZONE_PREFIX: "request-form-schedule-multistop-stop-timezone",
  REQUEST_FORM_SCHEDULE_MULTISTOP_STOP_NOTES_PREFIX: "request-form-schedule-multistop-stop-notes",
  REQUEST_FORM_SCHEDULE_MULTISTOP_STOP_CONTACT_NAME_PREFIX: "request-form-schedule-multistop-stop-contact-name",
  REQUEST_FORM_SCHEDULE_MULTISTOP_STOP_CONTACT_PHONE_PREFIX: "request-form-schedule-multistop-stop-contact-phone",
  REQUEST_FORM_SCHEDULE_MULTISTOP_STOP_CONTACT_EMAIL_PREFIX: "request-form-schedule-multistop-stop-contact-email",
};

export default testIds;
